import styled from "styled-components";
import {useState} from "react";
import {Button} from "@chakra-ui/react";
import {X} from "lucide-react";
import {useBaseCommunity, useLoggedIn, useStoreProfile} from "../../store";
import useModal from "../../modals";
import {themecolors} from "../../utils/themecolors";
import storage from "../../utils/storage";
import Sheet from "../bottom-sheet/sheet";
import SupportUsSheet from "../bottom-sheet/support_us";

const Container = styled.div``;
const Heading = styled.div``;
const Close = styled.button``;

const FeedContribute = styled(({className}) => {
    const modal = useModal();
    const loggedIn = useLoggedIn();
    const {expand} = useStoreProfile();

    // todo: also only show this if not Pro
    const [dismissed, setDismissed] = useState(() => storage.getItem("dismissedSupportInsert"));
    const handleDismiss = () => {
        storage.setItem("dismissedSupportInsert", true);
        setDismissed(true);
    }

    const [supportUsOpen, setSupportUsOpen] = useState(false);

    const baseCommunity = useBaseCommunity();

    return !dismissed && (
        <Container className={className} style={{marginBottom: 0, borderBottomWidth: expand === 'card' ? 0 : 1, borderTopWidth: expand === 'card' ? 1 : 0}}>
            <Heading>Support us</Heading>
            <p>{baseCommunity === "thedonald" ? "Platforms like this are only possible with your support." : "Free speech platforms are only possible with your support."}</p>
            <p>{loggedIn ? "Consider subscribing to Pro, or making a direct contribution." : "Consider making a contribution to protect free speech."}</p>
            <Button variant={"blue"} style={{width: '100%', marginTop: '24px'}} onClick={() => loggedIn ? setSupportUsOpen(true) : window.location.href="https://contribute.scored.co/" }>Support</Button>
            <Close onClick={handleDismiss}>
                <X size={20} />
            </Close>
            {supportUsOpen && <Sheet onClose={() => setSupportUsOpen(false) } padding={"header"}><SupportUsSheet onClose={() => setSupportUsOpen(false) } /></Sheet>}
        </Container>
    );
})`
  position: relative;
  padding: 20px 20px 24px 20px;
  border-top: 0px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  border-bottom: 0px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : theme.white_0};
  ${Heading} {
    font-size: 19px;
    font-weight: 600;
  }
  p {
    font-size: 15px;
    padding-bottom: 12px;
    padding-top: 18px;
  }
  p:last-of-type {
    padding-top: 0;
    padding-bottom: 0;
  }
  ${Close} {
    position: absolute;
    top: 24px;
    right: 24px;
  }
  ${Close} svg {
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_low_impact_text};
  }
  ${Close} svg:hover {
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_low_impact_text};
  }
`;

export default FeedContribute;